import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

const crudActions = restCrudActions({
    endpointBasePath: 'system-certificate',
    pluginName: 'ADMIN',
    entityName: 'SYSTEM_CERTIFICATE',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

export const uploadProgress = (data) => {
    return {
        type: 'SYSTEM_CERTIFICATE|PROGRESS',
        progress: data.progress,
        loadSize: data.loadSize,
        maxSize: data.maxSize,
        snackStart: data.snackStart

    };
};
export const fetchSystemCertificateInit = () => {
    return crudActions.fetchInit();
};
export const fetchSystemCertificateStart = () => {
    return crudActions.fetchStart();
};
export const fetchSystemCertificateSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchSystemCertificateFail = () => {
    return crudActions.fetchFail();
};
export const fetchSystemCertificateCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let countRes = await rest.post("system-certificate/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch system certificates."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch system certificates."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchSystemCertificate = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let listRes = await rest.post("system-certificate/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                return listRes.data.result.data
            }
            return []

        } catch (error) {
            return []
        }
    }
}

export const loadSystemCertificateInit = () => {
    return crudActions.loadInit();
};
export const loadSystemCertificateStart = () => {
    return crudActions.loadStart();
};
export const loadSystemCertificateSuccess = loadedSystemCertificate => {
    return crudActions.loadSuccess(loadedSystemCertificate);
};
export const loadSystemCertificateFail = error => {
    return crudActions.loadFail(error);
};
export const loadSystemCertificate = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

export const createSystemCertificateInit = () => {
    return crudActions.createInit();
};
export const createSystemCertificateStart = () => {
    return crudActions.createStart();
};
export const createSystemCertificateSuccess = createdSystemCertificate => {
    return crudActions.createSuccess(createdSystemCertificate);
};
export const createSystemCertificateFail = error => {
    return crudActions.createFail(error);
};

export const createSystemCertificate = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(uploadProgress({ progress: null, loadSize: null, maxSize: null, snackStart: true }))
        dispatch(createSystemCertificateInit());
        try {
            let maxSize = 0
            const config = {
                onUploadProgress: progressEvent => {
                    maxSize = Math.round((progressEvent.total / 1024));
                        dispatch(uploadProgress({
                            progress: (Math.round((progressEvent.loaded * 100) / data?.get('File')?.size) < 100 ? Math.round((progressEvent.loaded * 100) / data?.get('File')?.size) : '100'),
                            loadSize: Math.round((progressEvent.total / 1024)) < Math.round((progressEvent.loaded / 1024)) ? Math.round((progressEvent.loaded / 1024)) : Math.round((progressEvent.total / 1024)), maxSize: Math.round((progressEvent.total / 1024)), snackStart: true
                        }))
                }
            }
            dispatch(createSystemCertificateStart());
            let res = await rest.post('/system-certificate/create', data, config);
            if (res.status === 200) {
                dispatch(createSystemCertificateSuccess());
                dispatch(uploadProgress({ progress: 100, loadSize: maxSize, maxSize: maxSize, snackStart: false }))
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : 'Create system certificate was successful.'}`,
                    options: {
                        variant: 'success'
                    }
                });
                return true;
            }
            else {
                dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                dispatch(createSystemCertificateFail());
                return false;
            }
        } catch (error) {
            dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))

            snackActions.snackBar({
                message: `${error && error.message ? error.message : 'Cannot create system certificate.'}`,
                options: {
                    variant: 'error'
                }
            });
            dispatch(createSystemCertificateFail());
            return false;
        }
    }
}

export const editSystemCertificateInit = () => {
    return crudActions.editInit();
};
export const editSystemCertificateStart = () => {
    return crudActions.editStart();
};
export const editSystemCertificateSuccess = editedSystemCertificate => {
    return crudActions.editSuccess(editedSystemCertificate);
};
export const editSystemCertificateFail = error => {
    return crudActions.editFail(error);
};

export const editSystemCertificate = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editSystemCertificateStart());
        try {
            let res = await rest.post('/system-certificate/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated system certificate.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editSystemCertificateFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit system certificate."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit system certificate."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editSystemCertificateFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const bulkDeleteSystemCertificatesInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteSystemCertificatesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteSystemCertificatesSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteSystemCertificatesFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteSystemCertificates = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteSystemCertificatesStart());
        try {
            let res = await rest.post('/system-certificate/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteSystemCertificatesSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted system certificates.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteSystemCertificatesFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete system certificates."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete system certificates."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteSystemCertificatesFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};


export const listProductTypes = (params, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/product-type/list', params, options);
            if (res.data && res.data.succeeded) {
                const productTypes = [];
                for (var productType of res.data.result.data) {
                    productTypes.push({
                        value: `${productType.ProductTypeID}`,
                        label: `${productType.Name}`,
                        key: `${productType.Key}`
                    });
                }
                return productTypes.sort((a, b) => a.label.localeCompare(b.label));
            }
            else {
                if (res && res.canceled) {
                    return [''];
                }
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};